<template>
  <div class="max-w-lg w-full mx-auto">
    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
      <div class="mt-16 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6">
        <div class="text-center">
          <h1
            class="text-3xl tracking-tight font-black text-primary"
          >
            <span class="block" v-if="name">{{ name }}, we are getting ready.</span>
            <span class="block" v-else>We are getting ready.</span>
            <span class="block text-primary">Just give us a few moments.</span>
          </h1>
    
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: { name: String }
};
</script>